import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  paymentTerms: 'PaymentTerms',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.paymentTerms],
  endpoints: {
    getPaymentTerms: {
      providesTags: () => [{ type: TAG_TYPES.paymentTerms, id: 'LIST' }],
    },
    createPaymentTerm: {
      invalidatesTags: [{ type: TAG_TYPES.paymentTerms, id: 'LIST' }],
    },
    patchPaymentTerm: {
      invalidatesTags: (result, error, { paymentTermId }) => [
        { type: TAG_TYPES.paymentTerms, id: paymentTermId },
        { type: TAG_TYPES.paymentTerms, id: 'LIST' },
      ],
    },
    deactivatePaymentTerm: {
      invalidatesTags: [{ type: TAG_TYPES.paymentTerms, id: 'LIST' }],
    },
  },
})
export const {
  useGetPaymentTermsQuery,
  useCreatePaymentTermMutation,
  usePatchPaymentTermMutation,
  useDeactivatePaymentTermMutation,
} = api
